module.exports = __webpack_public_path__ + "static/media/Agro-Dealer_Needs_08-02-2024_C-removebg-preview.d2929118.png";